/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, November 7th 2022, 7:58:33 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { Mail } from "react-feather";
import { AjaxSourceForm } from "datasets/components/AjaxSourceForm";
import { AjaxSource } from "lib/schemas";
import { COLORSCHEME } from "theme/styles";
import { APIMany2OnePopupFormInput, IconText, Typography, ConcreteAPIRelatedFormPopupInputProps } from "ui-widgets";

export const AjaxSourcePopupInput = <T,>(props: ConcreteAPIRelatedFormPopupInputProps<T, AjaxSource>) => {
  return (
    <APIMany2OnePopupFormInput<T, AjaxSource>
      renderRelatedObjectForm={({ foreignKeyID, handleClose, updatePrimaryObject }) => (
        <AjaxSourceForm
          ajaxSourceID={foreignKeyID}
          onFormCancel={handleClose}
          onSuccessfulAPISave={(ajaxSource) => updatePrimaryObject(ajaxSource.id)}
        />
      )}
      label="Remote Data Source Configuration"
      popUpTitle={
        <IconText
          icon={<Mail color={COLORSCHEME.secondaryVariant} />}
          textComponent={<Typography variant="h5">Configure Remote Data Source</Typography>}
        />
      }
      popUpDescription="Configure remote connection settings for a remote data source."
      itemIdProperty="id"
      getOptionLabel={(option) => option.name}
      {...props}
    />
  );
};
